<template>
  <div class="capillariesView">
    <!-- 社区 -->
    <div class="categorys purple">
      <div class="title">
        <img class="icon" src="@/assets/vIcon.png" />
        社区
      </div>

      <div :class="`category ${postType === 'scratch' ? 'select' : ''}`" @click="setPostType('scratch')">
        <span class="circle"></span>
        <span class="text">Scratch社区</span>
        <span class="line" v-if="postType === 'scratch'"></span>
      </div>

      <div :class="`category ${postType === 'legocommunity' ? 'select' : ''}`" @click="setPostType('legocommunity')">
        <span class="circle"></span>
        <span class="text">乐高社区</span>
        <span class="line" v-if="postType === 'legocommunity'"></span>
      </div>

      <div :class="`category ${postType === 'appstore' ? 'select' : ''}`" @click="setPostType('appstore')">
        <span class="circle"></span>
        <span class="text">AppStore精选</span>
        <span class="line" v-if="postType === 'appstore'"></span>
      </div>

      <div :class="`category ${postType === 'codeQA' ? 'select' : ''}`" @click="setPostType('codeQA')">
        <span class="circle"></span>
        <span class="text">编程问答</span>
        <span class="number" v-if="new_post_count.oj_post_count !== 0">{{new_post_count.oj_post_count}}</span>
        <span class="line" v-if="postType === 'codeQA'"></span>
      </div>

      <div :class="`category ${postType === 'common' ? 'select' : ''}`" @click="setPostType('common')">
        <span class="circle"></span>
        <span class="text">朋友圈</span>
        <span class="number" v-if="new_post_count.common_post_count !== 0">{{new_post_count.common_post_count}}</span>
        <span class="line" v-if="postType === 'common'"></span>
      </div>   

      <div :class="`category ${postType === 'work' ? 'select' : ''}`" @click="setPostType('work')">
        <span class="circle"></span>
        <span class="text">作品圈</span>
        <span class="number" v-if="new_post_count.work_post_count !== 0">{{new_post_count.work_post_count}}</span>
        <span class="line" v-if="postType === 'work'"></span>
      </div>

      <!-- <div :class="`category ${postType === 'lego' ? 'select' : ''}`" @click="setPostType('lego')">
        <span class="circle"></span>
        <span class="text">乐高圈</span>
        <span class="number" v-if="new_post_count.lego_post_count !== 0">{{new_post_count.lego_post_count}}</span>
        <span class="line" v-if="postType === 'lego'"></span>
      </div> -->

      <div :class="`category ${postType === 'mentor' ? 'select' : ''}`" @click="setPostType('mentor')">
        <span class="circle"></span>
        <span class="text">师徒圈</span>
        <span class="number" v-if="new_post_count.school_count !== 0">{{new_post_count.school_count}}</span>
        <span class="line" v-if="postType === 'mentor'"></span>
      </div>

      <div :class="`category ${postType === 'video' ? 'select' : ''}`" @click="setPostType('video')">
        <span class="circle"></span>
        <span class="text">视频圈</span>
        <span class="number" v-if="new_post_count.video_post_count !== 0">{{new_post_count.video_post_count}}</span>
        <span class="line" v-if="postType === 'video'"></span>
      </div>

     <div :class="`category ${postType === 'active' ? 'select' : ''}`" @click="setPostType('active')">
        <span class="circle"></span>
        <span class="text">活动圈</span>
        <!-- <span class="number" v-if="new_post_count.active_post_count !== 0">{{new_post_count.active_post_count}}</span> -->
        <span class="line" v-if="postType === 'active'"></span>
      </div>

      <div :class="`category ${postType === 'cube' ? 'select' : ''}`" @click="setPostType('cube')">
        <span class="circle"></span>
        <span class="text">3D艺术圈</span>
        <span class="number" v-if="new_post_count.cube_post_count !== 0">{{new_post_count.cube_post_count}}</span>
        <span class="line" v-if="postType === 'cube'"></span>
      </div>   

      <div :class="`category ${postType === 'piskel' ? 'select' : ''}`" @click="setPostType('piskel')">
        <span class="circle"></span>
        <span class="text">像素艺术圈</span>
        <span class="number" v-if="new_post_count.piskel_post_count !== 0">{{new_post_count.piskel_post_count}}</span>
        <span class="line" v-if="postType === 'piskel'"></span>
      </div>   

      <!-- <div :class="`category ${postType === 'oj' ? 'select' : ''}`" @click="setPostType('oj')" >
        <img class="icon" :src="images.oj_icon" />
        <span class="text">OJ圈</span>
      </div> -->

      <div :class="`category ${postType === 'diary' ? 'select' : ''}`" @click="setPostType('diary')">
        <span class="circle"></span>
        <span class="text">心情日记</span>
        <span class="line" v-if="postType === 'diary'"></span>
      </div>

      <div :class="`category ${postType === 'contest' ? 'select' : ''}`" @click="setPostType('contest')">
        <span class="circle"></span>
        <span class="text">竞赛圈</span>
        <span class="number" v-if="new_post_count.contest_post_count !== 0">{{new_post_count.contest_post_count}}</span>
        <span class="line" v-if="postType === 'contest'"></span>
      </div>

      <div :class="`category ${postType === 'company' ? 'select' : ''}`" @click="setPostType('company')">
        <span class="circle"></span>
        <span class="text">公司圈</span>
        <!-- <span class="number" v-if="new_post_count.company_count !== 0">{{new_post_count.company_count}}</span> -->
        <span class="line" v-if="postType === 'company'"></span>
      </div>

      <!-- <div :class="`category ${postType === 'science' ? 'select' : ''}`" @click="setPostType('science')">
        <span class="circle"></span>
        <span class="text">科普圈</span>
        <span class="number" v-if="new_post_count.science_post_count !== 0">{{new_post_count.science_post_count}}</span>
        <span class="line" v-if="postType === 'science'"></span>
      </div> -->

      <!-- <div :class="`category ${postType === 'move' ? 'select' : ''}`" @click="setPostType('move')">
        <span class="circle"></span>
        <span class="text">搬运圈</span>
        <span class="number" v-if="new_post_count.move_post_count !== 0">{{new_post_count.move_post_count}}</span>
        <span class="line" v-if="postType === 'move'"></span>
      </div> -->

      <!-- <div :class="`category ${postType === 'mago' ? 'select' : ''}`" @click="setPostType('mago')">
        <span class="circle"></span>
        <span class="text">MagO杂志</span>
        <span class="number" v-if="new_post_count.mago_post_count !== 0">{{new_post_count.mago_post_count}}</span>
        <span class="line" v-if="postType === 'mago'"></span>
      </div> -->
    </div>


    <!-- 开放平台 -->
    <div class="categorys orange">
      <div class="title">
        <img class="icon" src="@/assets/work_icon.png" />
        开放平台
      </div>
      <div class="category " @click="goWebSite('/html/blue-diamond-mall/blue-diamond-mall.html')">
        <span class="circle"></span>
        <span class="text">蓝钻商城</span>
      </div>
      
      <div class="category " @click="goWebSite('/face2face/app/home/homeClass.html')">
        <span class="circle"></span>
        <span class="text">AI课</span>
      </div>

      <div class="category " @click="goWebSite('https://www.coding61.com/mobile/html/bookClub.html?from=singlemessage&isappinstalled=0')">
        <span class="circle"></span>
        <span class="text">斌叔科普</span>
      </div>

      <div class="category " @click="goWebSite('contest')">
        <span class="circle"></span>
        <span class="text">联赛</span>
      </div>
      
      <div class="category " @click="goWebSite('https://3.coding61.com/')">
        <span class="circle"></span>
        <span class="text">短网址</span>
      </div>
      <div class="category " @click="goWebSite('/typing/html/index/index.html')">
        <span class="circle"></span>
        <span class="text">打字精灵</span>
      </div>

      <div class="category " @click="goWebSite('/index/#adventureGame')">
        <span class="circle"></span>
        <span class="text">冒险岛</span>
      </div>

      <div class="category " @click="goWebSite('/girl/decades-theme/index-image/index.html')">
        <span class="circle"></span>
        <span class="text">程序媛</span>
      </div>
    </div>


    <!-- 编辑器 -->
    <div class="categorys blue">
      <div class="title">
        <img class="icon" src="@/assets/bookIcon.png" />
        编辑器
      </div>
      <div class="category " @click="goWebSite('/html/goScratch/goScratch.html')">
        <span class="circle"></span>
        <span class="text">Scratch</span>
      </div>

      <div class="category " @click="goWebSite('/projects/gamelab/index/')">
        <span class="circle"></span>
        <span class="text">游戏工作室</span>
      </div>

      <div class="category " @click="goWebSite('/projects/applab/index/')">
        <span class="circle"></span>
        <span class="text">Applab</span>
      </div>

      <div class="category " @click="goWebSite('/turtle/index.html#new')">
        <span class="circle"></span>
        <span class="text">Python</span>
      </div>

      <div class="category " @click="goWebSite('/face2face/app/home/codeCompileRN.html?lang=cpp')">
        <span class="circle"></span>
        <span class="text">C++</span>
      </div>

      <div class="category " @click="goWebSite('/face2face/app/home/codeEditRN.html')">
        <span class="circle"></span>
        <span class="text">HTML</span>
      </div>

      <div class="category " @click="goWebSite('/v86/basic.html')">
        <span class="circle"></span>
        <span class="text">Linux<br />在线环境</span>
      </div>

      <div class="category " @click="goWebSite('https://3d.coding61.com')">
        <span class="circle"></span>
        <span class="text">3D在线编辑器</span>
      </div>
    </div>
  </div>
</template>

<script>
import { types as CommunityTypes } from "@/store/modules/community";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "Capillaries",
  components: {},
  props: {
    postType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      
    };
  },
  watch: {},
  computed: {
    ...mapState({
     new_post_count: state => state.community.new_post_count
    }),
    ...mapGetters({})
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
    }),
    setPostType(type){
      if(this.$parent.setPostType){
        this.$parent.setPostType(type);
     
      }
        //  this.$router.push({name:"actives"})
    },
    // 去其他网页
    goWebSite (url) {
      if (url == 'contest') {// 单独处理联赛
        let today = new Date()
        let week = today.getDay() //获取当前周几
        let day = today.getDate() // 获取当前的日期
        if (week == 6 && day < 8) { // 第一个周的周六的日期一定在1~7号
          window.open('/index/Contest', '_blank')
        } else if (week == 0 && 1 < day && day < 9) {// 第一个周的周日的日期一定在2~8号
          window.open('/index/Contest', '_blank')
        } else {
          this.$message("还未到比赛时间，开放时间为每个月第一个周六、周日")
        }

      } else {
        window.open(url, '_blank')
      }
    }
  },
  created() {},
  destroyed() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.capillariesView {
  position: relative;
  width: 100%;
  .purple.categorys .circle {
    background: #774ee5;
  }
  .orange.categorys .circle {
    background: #ff7b00;
  }
  .blue.categorys .circle {
    background: #0084ff;
  }
  .categorys {
    padding-bottom: 13px;
    margin: 10px;
    border-bottom: 1px solid #e6e6e6;
    .title {
      color: #666;
      font-size: 16px;
      display: flex;
      align-items: center;
      height: 45px;
      img {
        width: 20px;
        margin-right: 5px;
      }
    }
    .category {
      display: flex;
      flex-direction: row;
      // align-items: baseline;
      align-items: center;
      font-size: 15px;
      color: #333333;
      height: 35px;
      cursor: pointer;
      .icon {
        width: 25px;
        margin-right: 5px;
        height: 25px;
      }
      .circle {
        display: inline-block;
        height: 6px;
        width: 6px;
        border-radius: 50%;
        margin-right: 5px;
        position: relative;
        // bottom: 2px;
        left: 0;
      }
      .text{
        text-align: center;
      }
      .number {
        margin-left: 5px;
        min-width: 18px;
        height: 13px;
        line-height: 14px;
        text-align: center;
        display: inline-block;
        padding: 0 0px;
        color: #fff;
        border-radius: 3px;
        background-color: #ff6600;
        font-size: 8px;
      }
      &.select {
        color: #6b45e1;
        font-weight: bold;
        .line {
          border-right: solid 3px #6b45e1;
          height: 20px;
          flex: 1;
          right: -10px;
          position: relative;
        }
      }
    }
  }
}
</style>
